<div class="info-lines">
  <div class="info-lines__title" id="{{title}}">{{title}}</div>
  <div class="info-lines__information">
    <div class="info-lines__line" *ngFor="let line of lines">
      <div class="info-lines__line__name" id="{{line.title}}" translate>{{line.title}}</div>
      <ng-container [ngSwitch]="line.type">
        <div class="info-lines__line__value" id="{{line.title}}_value" *ngSwitchCase="'date'">{{line.value}}</div>
        <div class="info-lines__line__value" id="{{line.title}}_valueDate" [ngClass]="line.cssClass" *ngSwitchDefault>{{line.value}}</div>
      </ng-container>
    </div>
  </div>
</div>
